import { Dispatch, SetStateAction, useState } from "react";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import {
  Modal,
  Button,
  Box,
  Checkbox,
  InputBase,
  ListItemText,
  MenuItem,
  Select,
} from "@mui/material";

interface AddCategoryModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
}

export default function AddtoGroup({
  open,
  onClose,
  setOpen,
}: AddCategoryModalProps) {
  const [selectedGroups, setSelectedGroups] = useState<string[]>([]);
  const groupOptions = [
    { label: "Group 1", value: "10" },
    { label: "Group 2", value: "20" },
    { label: "Group 3", value: "30" },
    { label: "Group 4", value: "40" },
  ];
  const [searchTerm, setSearchTerm] = useState("");
  const filteredOptions = groupOptions.filter((option) =>
    option.label.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleGroupChange = (event: any) => {
    const {
      target: { value },
    } = event;
    setSelectedGroups(typeof value === "string" ? value.split(",") : value);
  };
  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
  };
  return (
    <Modal className="modal addCategory_modal" open={open} onClose={onClose}>
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="modal_title text_center mb_30">
            <h2>Add </h2>
            <div className="btn-close" onClick={() => setOpen(false)}>
              <CloseIcon />
            </div>
          </div>
          <form className="form" action="">
            <div className="control_group w_50">
              <label>Groups</label>
              <Select
                
                displayEmpty
                className="dropse"
                value={selectedGroups}
                onChange={handleGroupChange}
                input={<InputBase />}
                renderValue={(selected) => {
                  if (selected.length === 0) return <span>Select Group</span>;
                  return groupOptions
                    .filter((opt) => selected.includes(opt.value))
                    .map((opt) => opt.label)
                    .join(", ");
                }}
                MenuProps={{
                  PaperProps: { style: { maxHeight: 300, padding: 0 } },
                }}
              >
                <Box px={2} pt={1} pb={1}>
                  <TextField
                    fullWidth
                    placeholder="Search..."
                    value={searchTerm}
                    onChange={handleSearchChange}
                    variant="standard"
                    autoFocus
                  />
                </Box>

                {filteredOptions.map((option) => (
                  <MenuItem
                    key={option.value}
                    value={option.value}
                    className="multi_check_select"
                  >
                    <Checkbox checked={selectedGroups.includes(option.value)} />
                    <ListItemText primary={option.label} />
                  </MenuItem>
                ))}
              </Select>
            </div>
            <div className="footer_btn_flex">
              <Button
                className="btn btn_primary"
                onClick={() => setOpen(false)}
              >
                Submit
              </Button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
}
